import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface ServiceDetailProps {
  service: {
    category: string;
    title: string;
    description: string;
    features: string[];
    image: string;
    reverse: boolean;
  };
}

const ServiceDetail = ({ service }: ServiceDetailProps) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/iletisim');
  };

  return (
    <div ref={ref} className={`grid lg:grid-cols-2 gap-16 items-center ${service.reverse ? 'lg:flex-row-reverse' : ''}`}>
      {/* Image */}
      <motion.div
        initial={{ opacity: 0, x: service.reverse ? 50 : -50 }}
        animate={inView ? { opacity: 1, x: 0 } : {}}
        transition={{ duration: 0.8 }}
        className={`${service.reverse ? 'lg:order-2' : ''}`}
      >
        <div className="relative rounded-[32px] overflow-hidden shadow-2xl">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      </motion.div>

      {/* Content */}
      <motion.div
        initial={{ opacity: 0, x: service.reverse ? -50 : 50 }}
        animate={inView ? { opacity: 1, x: 0 } : {}}
        transition={{ duration: 0.8 }}
        className={`${service.reverse ? 'lg:order-1' : ''}`}
      >
        {/* Category Badge */}
        <div className="inline-block mb-4">
          <div className="px-4 py-2 bg-[#007dff]/10 rounded-full border border-[#007dff]">
            <span className="font-poppins font-medium text-sm text-[#007dff]">
              {service.category}
            </span>
          </div>
        </div>

        {/* Title */}
        <h2 className="font-poppins font-semibold text-4xl lg:text-5xl text-gray-900 mb-6">
          {service.title}
        </h2>

        {/* Description */}
        <p className="font-poppins text-lg text-gray-600 mb-8 leading-relaxed">
          {service.description}
        </p>

        {/* Features List */}
        <ul className="space-y-4 mb-8">
          {service.features.map((feature, index) => (
            <li key={index} className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center bg-[#007dff]/10 rounded-full flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-[#007dff] text-sm"></i>
              </div>
              <span className="font-poppins text-[15px] text-gray-700">
                {feature}
              </span>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <button
          onClick={scrollToContact}
          className="px-8 py-3.5 border-2 border-[#007dff] text-[#007dff] rounded-lg font-poppins font-semibold text-[15px] hover:bg-[#007dff] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Detaylı Bilgi Al
        </button>
      </motion.div>
    </div>
  );
};

export default ServiceDetail;
